import { inflate } from 'pako';

export const decompress = async <T>(data: string): Promise<T> => {
  const inflated = inflate(Buffer.from(data, 'base64'), { to: 'string' });
  return JSON.parse(inflated);
};
